import * as angular from "angular";

export class ExpensesCategoriesDialogService {


  constructor(private $mdDialog) {

  }

  createCategory(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-category-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.header = 'Create Category';

        $scope.cancel = self.$mdDialog.cancel;
        $scope.expensesCategory = {
          name: undefined
        }
        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.expensesCategory);
        }

      }
    })
  }

  editCategory(category, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/create-category-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.header = 'Edit Category';

        $scope.cancel = self.$mdDialog.cancel;
        $scope.expensesCategory = category;

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.expensesCategory);
        }

      }
    })
  }


}

angular
  .module('bringoz.admin.expenses')
  .service('expensesCategoriesDialogService', ExpensesCategoriesDialogService);
